import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/mergeMap';

import { AuthService } from './auth.service';
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private auth: AuthService,
    private router: Router,
    private db: AngularFireDatabase,
  ) {}

  getUserRole(user): any {
    return this.db.list('prod/profiles', {
      query: {
        orderByKey: true,
        equalTo: user.uid
      }
    });
  }

  canActivate(): Observable<boolean> {
    return this.auth.afAuth.authState.mergeMap(user =>
      // Extract the role from userData if user exists, or empty string if no user.
      user ? this.getUserRole(user).map(userData => userData[0].role) : Observable.of('')
    )
    // Transform the role into true or false
    // since this is what canActivate() must return.
    .map(userRole => {
      if (userRole === 'admin') {
        return true;
      } else {
        this.router.navigate(['/signin']);
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/src/app/auth.guard.ts